import { Component, EventEmitter, Input, Output } from "@angular/core";
import { GloTagComponent } from "../tag/tag.component";
import { RouterLink } from "@angular/router";
import { API_ENDPOINTS } from "../../services/api/api-endpoints";
import { ApiService } from "../../services/api/api.service";
import { Salon } from "../../models/salon.model";
import { CommonModule } from "@angular/common";
import { LoaderComponent } from "../loader/loader.component";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "glo-card-landing",
  imports: [GloTagComponent, RouterLink, CommonModule, LoaderComponent],
  templateUrl: "./card-landing.component.html",
  styleUrl: "./card-landing.component.scss",
})
export class CardLandingComponent {
  @Input() hasLeftIcon = true;
  @Input() hasRightIcon = true;
  @Input() salon: Salon = {} as Salon;

  assetUrl = environment.assetBaseUrl;

  @Output() afterToggle = new EventEmitter<{
    salonId: string;
    isFavorite: boolean;
  }>();

  @Output() onLoad = new EventEmitter<boolean>();

  isLoading = false;

  constructor(private ApiService: ApiService) {}

  getDisplayServices(): string[] {
    if (!this.salon?.services) {
      return ["Hair", "Coloring", "Hair Removal"];
    }

    return this.salon.services.slice(0, 3).map((service) => service.name);
  }

  getSalonLocation(): string {
    if (this.salon?.address && this.salon?.city) {
      return `${this.salon.address}, ${this.salon.city}`;
    } else if (this.salon?.city) {
      return this.salon.city;
    }

    return "Dolphin's Barn Street";
  }

  AddToFav(e: Event, id?: string) {
    if (!id || this.isLoading) return;

    e.stopPropagation();
    e.preventDefault();

    const previousState = this.salon.is_favorite;
    this.salon.is_favorite = !this.salon.is_favorite;
    this.isLoading = true;

    this.ApiService.request(
      API_ENDPOINTS.customer.favoritesSalons.toggle(id),
      "POST",
      {},
      "Salon Updated Successfuly!",
    ).subscribe({
      next: () => {
        this.afterToggle.emit({
          salonId: id,
          isFavorite: this.salon.is_favorite,
        });

        this.isLoading = false;
      },
      error: () => {
        if (this.salon) {
          this.salon.is_favorite = previousState;
        }

        this.isLoading = false;
      },
    });
  }
}
